import { InputText } from 'primereact/inputtext';
import { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Calendar, CalendarChangeEvent } from 'primereact/calendar';

interface CanceledOrderSearchProps {
    onSearch: (filters: {
        phoneNumber?: string;
        startDate?: Date;
        endDate?: Date;
    }) => void;
    onReset: () => void;
    defaultStartDate?: Date;
    defaultEndDate?: Date;
}

const CanceledOrderSearch: React.FC<CanceledOrderSearchProps> = ({ 
    onSearch, 
    onReset,
    defaultStartDate,
    defaultEndDate 
}) => {
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
     const [startViewDate, setStartViewDate] = useState<Date>(new Date());
    const [endViewDate, setEndViewDate] = useState<Date>(new Date());

useEffect(() => {
        if (defaultStartDate) {
            setStartDate(new Date(defaultStartDate));
        }
 
        if (defaultEndDate) {
            setEndDate(new Date(defaultEndDate));
        }
    }, [defaultStartDate, defaultEndDate]);

    const handleSearch = () => {
        onSearch({
            phoneNumber: phoneNumber || undefined,
            startDate: startDate || undefined,
            endDate: endDate || undefined
        });
    };

    const handleReset = () => {
        setPhoneNumber('');
        setStartDate(null);
        setEndDate(null);
        onReset();
    };

    return (
        <div className="col-12">
            <div className="card border-noround p-3" style={{ minHeight: '3.5rem' }}>
                <div className="flex flex-wrap align-items-center gap-3">
                    <div className="p-input-icon-left" style={{ flex: '1 1 5%' }}>
                        <i className="pi pi-search" />
                        <InputText
                            placeholder="Search for Mobile Number"
                            style={{ width: '100%' }}
                            value={phoneNumber}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value) && value.length <= 10) {
                                    setPhoneNumber(value);
                                }
                            }}
                        />
                    </div>
    
                    <div className="flex gap-2" style={{ flex: '1 1 20%' }}>
                        <Calendar
                         key={startDate ? 'start-set' : 'start-null'}
                        value={startDate}
                        dateFormat="dd/mm/yy"
                        placeholder="Start date"
                        onChange={(e: CalendarChangeEvent) => setStartDate(e.value as Date)}
                        style={{ width: '30%' }}
                        readOnlyInput
                        />
                        <Calendar
                        key={endDate ? 'end-set' : 'end-null'}
                        value={endDate}
                        dateFormat="dd/mm/yy"
                        placeholder="End date"
                        onChange={(e: CalendarChangeEvent) => setEndDate(e.value as Date)}
                        style={{ width: '30%' }}
                        readOnlyInput
                        />
                    </div>
    
                    <div className="flex gap-2 justify-content-end ml-auto" style={{ flex: '1 1 20%' }}>
                        <Button
                            className="text-black border-round p-button-m"
                            severity="success"
                            raised
                            label="Filter"
                            style={{ width: "30%" }}
                            onClick={handleSearch}
                        />
                        <Button
                            className="text-black border-round p-button-m"
                            severity="secondary"
                            text
                            raised
                            label="Reset"
                            style={{ width: "30%" }}
                            onClick={handleReset}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
    
};

export default CanceledOrderSearch;